<svg
  [attr.width]="size"
  [attr.height]="size"
  fill="none"
  viewBox="0 0 16 16"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M6.42678 4.42675L9.82322 7.82323C9.92085 7.92086 9.92085 8.07915 9.82322 8.17678L6.42678 11.5732C6.26928 11.7307 6 11.6192 6 11.3965V4.60353C6 4.3808 6.26929 4.26926 6.42678 4.42675Z"
    fill="currentColor"
  />
</svg>
